/**
 * https://docs.venom.foundation/learn/accounts/#address
 */

export default {
  isValidAddress: function (address, currency, networkType) {

    if (!address.startsWith('0:') || address.slice(2).length !== 64) {
      return false;
    }

    const cleanAddress = address.slice(2);

    return new RegExp(/^[0-9a-fA-F]{64}$/).test(cleanAddress);
  }
}